var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1007_13589",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 26,
    height: 26
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1007_13589)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 12.9997C11.8084 12.9997 10.7882 12.5754 9.93962 11.7268C9.09101 10.8781 8.66671 9.85801 8.66671 8.66634C8.66671 7.47467 9.09101 6.45454 9.93962 5.60592C10.7882 4.75731 11.8084 4.33301 13 4.33301C14.1917 4.33301 15.2118 4.75731 16.0605 5.60592C16.9091 6.45454 17.3334 7.47467 17.3334 8.66634C17.3334 9.85801 16.9091 10.8781 16.0605 11.7268C15.2118 12.5754 14.1917 12.9997 13 12.9997ZM4.33337 21.6663V18.633C4.33337 18.0191 4.49154 17.4547 4.80787 16.9398C5.12349 16.4255 5.5431 16.033 6.06671 15.7622C7.18615 15.2025 8.32365 14.7825 9.47921 14.5023C10.6348 14.2228 11.8084 14.083 13 14.083C14.1917 14.083 15.3653 14.2228 16.5209 14.5023C17.6764 14.7825 18.8139 15.2025 19.9334 15.7622C20.457 16.033 20.8766 16.4255 21.1922 16.9398C21.5085 17.4547 21.6667 18.0191 21.6667 18.633V21.6663H4.33337ZM6.50004 19.4997H19.5V18.633C19.5 18.4344 19.4506 18.2538 19.3516 18.0913C19.252 17.9288 19.1209 17.8025 18.9584 17.7122C17.9834 17.2247 16.9993 16.8589 16.0063 16.6148C15.0132 16.3714 14.0112 16.2497 13 16.2497C11.9889 16.2497 10.9868 16.3714 9.99379 16.6148C9.00074 16.8589 8.01671 17.2247 7.04171 17.7122C6.87921 17.8025 6.74849 17.9288 6.64954 18.0913C6.54987 18.2538 6.50004 18.4344 6.50004 18.633V19.4997ZM13 10.833C13.5959 10.833 14.1061 10.6207 14.5308 10.196C14.9547 9.77206 15.1667 9.26217 15.1667 8.66634C15.1667 8.07051 14.9547 7.56062 14.5308 7.13667C14.1061 6.71201 13.5959 6.49967 13 6.49967C12.4042 6.49967 11.8943 6.71201 11.4704 7.13667C11.0457 7.56062 10.8334 8.07051 10.8334 8.66634C10.8334 9.26217 11.0457 9.77206 11.4704 10.196C11.8943 10.6207 12.4042 10.833 13 10.833Z",
    fill: "#FAFAFA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.7b4f7cc0fc66fdcf79925a67e8fb021a.svg";
export { ForwardRef as ReactComponent };